import { useMutation, useQuery } from '@tanstack/react-query'
import { instance } from '../instance'
export const useFetchRoles = (filters: Filters) => {
  const { pageSize = 10 } = filters
  const fetchAllRoles = async (): Promise<FetchRolesResponse> => {
    const response = await instance.get(
      `/admin-dashboard/Role?searchTerm=${filters.searchTerm}&pageNumber=${filters.pageNumber}&pageSize=${pageSize}`,
    )
    return response.data
  }
  const queryApi = useQuery({
    queryKey: ['fetch all Roles', filters],
    queryFn: fetchAllRoles,
  })
  return queryApi
}
export const useCreateRole = () => {
  const createNewRole = async (
    payload: CreateRolePayload,
  ): Promise<CreateRolesResponse> => {
    const response = await instance.post(`/admin-dashboard/role`, payload)
    return response.data
  }
  const mutateAPI = useMutation({
    mutationKey: ['Create new Role'],
    mutationFn: (payload: CreateRolePayload) => createNewRole(payload),
  })
  return mutateAPI
}
